// NOT: docs/assets/mqle-quick-add.js.md — gerekceler ve KONTRATLAR orada. Degistirmeden once oku.
class MqleQuickAdd extends HTMLElement {
  connectedCallback() {
    this.cache = new Map();
    this.panel = this.querySelector('[data-qa-content]');
    const hit = (e) => e.target.closest?.('[data-card-quick-add]');

    document.addEventListener('pointerdown', (e) => this.load(hit(e)?.dataset.productUrl), true);
    document.addEventListener('click', (e) => {
      const t = hit(e);
      if (!t || t.disabled) return;
      e.preventDefault();
      e.stopPropagation();
      this.open(t);
    }, true);
    document.addEventListener('keydown', (e) => !this.hidden && e.key === 'Escape' && this.close());
    this.addEventListener('click', this.onClick.bind(this));
  }

  load(url) {
    if (!url) return null;
    if (!this.cache.has(url)) {
      this.cache.set(url, fetch(`${url}${url.includes('?') ? '&' : '?'}section_id=mqle-quick-add`)
        .then((r) => r.text())
        .then((t) => new DOMParser().parseFromString(t, 'text/html').querySelector('[data-qa-panel]')?.outerHTML));
    }
    return this.cache.get(url);
  }

  async open(trigger) {
    this.opener = trigger;
    this.hidden = false;
    this.panel.innerHTML = '';
    document.body.classList.add('mqle-qa-open');
    requestAnimationFrame(() => this.setAttribute('open', ''));

    const html = await this.load(trigger.dataset.productUrl);
    if (!html) return this.close();
    this.panel.innerHTML = html;
    this.select(this.panel.querySelector('[data-qa-swatch-checked], [aria-checked="true"]')?.dataset.variantId);

    const list = this.panel.querySelector('[data-qa-list]');
    const fill = this.panel.querySelector('.mqle-qa__progress-fill');
    if (list && fill) {
      const step = list.children[0].offsetWidth;
      fill.style.width = `${100 / list.children.length}%`;
      list.addEventListener('scroll', () => {
        fill.style.transform = `translateX(${Math.round(list.scrollLeft / step) * 100}%)`;
      });
    }

    (this.querySelector('.mqle-qa__heading') || this.panel.querySelector('[data-qa-add]'))?.focus();
  }

  close(focusTarget) {
    this.removeAttribute('open');
    document.body.classList.remove('mqle-qa-open');
    const target = focusTarget || this.opener;
    setTimeout(() => {
      this.hidden = true;
      this.panel.innerHTML = '';
      target?.focus();
    }, 220);
  }

  select(id) {

    const swatches = [...this.panel.querySelectorAll('[role="radio"][data-qa-pick]')];
    const swatch = swatches.find((n) => n.dataset.variantId === String(id)) || swatches[0];
    if (!swatch) return;
    const v = swatch.dataset;

    this.panel.querySelectorAll('[data-qa-pick]').forEach((n) => n.setAttribute(
      n.getAttribute('role') === 'radio' ? 'aria-checked' : 'aria-selected', n.dataset.variantId === v.variantId));

    const set = (sel, text) => {
      const node = this.panel.querySelector(sel);
      if (node) node.textContent = text;
    };
    set('[data-qa-shade-name]', v.title);
    set('[data-qa-shade-tone]', v.tone);

    const dot = this.panel.querySelector('[data-qa-select] [data-qa-dot]');
    if (dot) dot.setAttribute('style', swatch.getAttribute('style') || '');

    const price = this.panel.querySelector('.price');
    if (price) {
      price.classList.toggle('price--on-sale', !!v.compare);
      const sep = price.dataset.priceSep || '';
      price.querySelectorAll('[data-card-price]').forEach((n) => {
        const major = n.querySelector('[data-card-price-major]') || n;
        const minor = n.querySelector('[data-card-price-minor]');
        const cut = sep ? v.price.lastIndexOf(sep) : -1;
        if (minor && cut > 0) {
          major.textContent = v.price.slice(0, cut);
          minor.textContent = v.price.slice(cut);
        } else {
          major.textContent = v.price;
        }
      });
      set('[data-card-compare]', v.compare);
      set('[data-card-price-a11y]', v.priceA11y);
      const pct = price.querySelector('[data-card-discount]');
      if (pct) pct.lastChild.textContent = v.pct;
    }

    const add = this.panel.querySelector('[data-qa-add]');
    if (add) {
      add.dataset.variantId = v.variantId;
      add.disabled = v.available !== 'true';
    }
    const list = this.panel.querySelector('[data-qa-list]');
    this.renkFiltresi(list, v.renk);
    const slide =
      (v.mediaId && list?.querySelector('[data-media-id="' + v.mediaId + '"]')) ||
      list?.children[+v.media];
    if (slide)
      list.scrollTo({
        left: slide.offsetLeft - list.offsetLeft - (list.clientWidth - slide.offsetWidth) / 2,
        behavior: 'smooth',
      });
  }

  renkFiltresi(list, renk) {
    if (!list) return;
    list.querySelectorAll('[data-mqle-renk]').forEach((el) => {
      const r = el.getAttribute('data-mqle-renk');
      el.hidden = !!(renk && r && r !== renk);
    });
  }

  onClick(e) {
    const t = e.target;
    if (t.closest('[data-qa-close]') || t === this) return this.close();

    const step = t.closest('[data-qa-qty]');
    if (step) {
      const input = this.panel.querySelector('[data-qa-qty-input]');
      input.value = Math.max(1, (parseInt(input.value, 10) || 1) + +step.dataset.qaQty);
      return;
    }

    const choice = t.closest('[data-qa-pick]');
    if (choice) {
      if (choice.getAttribute('aria-disabled') === 'true') return;
      this.select(choice.dataset.variantId);
      this.panel.querySelector('[data-qa-select]')?.removeAttribute('open');
      return;
    }
    if (t.closest('[data-qa-add]')) this.add();
  }

  async add() {
    const button = this.panel.querySelector('[data-qa-add]');
    const error = this.panel.querySelector('[data-qa-error]');
    button.disabled = true;
    error.hidden = true;

    if (!this.opener?.closest('cart-drawer')) document.querySelector('cart-drawer')?.openPending?.();

    document.querySelector('cart-drawer')?.renderOptimisticLine?.(this.panel);
    try {
      const response = await fetch(`${routes.cart_add_url}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
        body: JSON.stringify({
          items: [{ id: +button.dataset.variantId, quantity: +this.panel.querySelector('[data-qa-qty-input]').value || 1 }],
          sections: 'cart-drawer,cart-icon-bubble',
        }),
      });
      const data = await response.json();
      if (data.status) throw new Error(data.description || data.message);
      const drawer = document.querySelector('cart-drawer');
      if (!drawer) return (window.location.href = routes.cart_url);

      const fromDrawer = this.opener?.closest('cart-drawer');
      drawer.renderContents(data);
      syncEmptyState();
      this.close(fromDrawer ? drawer.querySelector('.cart-item__name, .drawer__heading') : null);
    } catch (exception) {
      document.querySelector('cart-drawer')?.closePending?.();
      error.textContent = exception.message;
      error.hidden = false;
      button.disabled = false;
    }
  }
}

customElements.define('mqle-quick-add', MqleQuickAdd);

function syncEmptyState() {
  const drawer = document.querySelector('cart-drawer');
  if (drawer) drawer.classList.toggle('is-empty', !drawer.querySelector('.cart-item'));
}

if (typeof subscribe === 'function') subscribe(PUB_SUB_EVENTS.cartUpdate, syncEmptyState);
